import * as React from "react";
import OrgProfile from "../../components/AdminPanelComponent/OrgProfile";
import OrganizationAccess from '../../components/AdminPanelComponent/OrganizationAccess';
import ManageCommunication from '../../components/AdminPanelComponent/ManageCommunication';
import Settings from '../../components/AdminPanelComponent/Settings';
import Users from '@components/AdminPanelComponent/Users';
import ManageWorkload from '@components/AdminPanelComponent/Users/workloadManage.jsx';
import Relationships from '../../components/AdminPanelComponent/relationships';
import Parties from "../../components/AdminPanelComponent/parties";
import Rules from "../../components/AdminPanelComponent/Rules";
import { useModules } from '../../utils/modules';

// import { CompanyProfileLoader } from '../../components/SkeletonLoader';

function AdminPanel() {
    const { isModuleEnabled } = useModules();

    const renderAdminPanelComponent = () => {
        let pathName = window.location.pathname.toLowerCase();

        if (pathName.startsWith("/users/manageworkload/")) {
            return <ManageWorkload />
        }

        if (pathName === "/users/add" || pathName.startsWith("/users/edit/") || pathName.startsWith("/user-profile/")) {
            return <Users />
        }

        switch(pathName)
        {
            case ("/orgaccess"):
                return isModuleEnabled("admin.organization_access") && <OrganizationAccess />
            case ("/managecomm"):
                return isModuleEnabled("admin.communication") && <ManageCommunication />
            case ("/settings"):
                return isModuleEnabled("admin.settings") && <Settings />
            case ("/users"):
                return <Users />
            case ("/relationships"):
                return <Relationships />
            case "/parties":
                return isModuleEnabled("parties") && <Parties/>;
            case "/ruleengine":
                return isModuleEnabled("admin.rule_engine") && <Rules />
            default:
                return <OrgProfile />
            break;    

        }
    }   
    
    return(
        <>{renderAdminPanelComponent()}</>
        // <div id ="admin-content" className="profileSettingContainer">
        //     {
        //     isLoading && <CompanyProfileLoader />
        //     }
        //     {
        //         Object.keys(orgProfileData).length > 0 && this.renderAdminPanelComponent()
        //     } 
        // </div>
    )

}
export default AdminPanel;
